import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';
import { useNavigate } from 'react-router-dom';

const ConfirmedBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [filterDate, setFilterDate] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchBookings();
  }, []);

  useEffect(() => {
    const filtered = bookings.filter((item) => {
      const text = searchText.toLowerCase();
      const matchesText =
        item.name?.toLowerCase().includes(text) ||
        item.status?.toLowerCase().includes(text) ||
        item.phone?.toString().includes(text) ||
        item.email?.toLowerCase().includes(text) ||
        item.amount?.toLowerCase().includes(text) ||
        item.booking_id?.toLowerCase().includes(text) ||
        item.payment_method?.toLowerCase().includes(text) ||
        item.date?.toLowerCase().includes(text);

      const matchesDate = filterDate ? item.date === filterDate : true;

      return matchesText && matchesDate;
    });

    setFilteredData(filtered);
  }, [searchText, filterDate, bookings]);

  const fetchBookings = () => {
    setLoading(true);
    DataService.getConfirmedBookings()
      .then((response) => {
        // Sort by most recent created_at
        const sorted = [...response.data].sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });

        setBookings(sorted);
        setFilteredData(sorted);
      })
      .catch((error) => {
        console.error('Failed to fetch confirmed bookings:', error);
      })
      .finally(() => setLoading(false));
  };

  const columns = [
    {
      name: 'Booking ID',
      selector: row => row.booking_id,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Name',
      selector: row => row.name,
      sortable: true,
    },
    {
      name: 'Phone',
      selector: row => row.phone,
    },
    {
      name: 'Email',
      selector: row => row.email,
      grow: 2,
      wrap: true,
    },
    {
      name: 'Payment',
      selector: row => row.payment_method,
      grow: 2,
    },
    {
      name: 'Date',
      selector: row => row.date,
      wrap: true,
    },
    {
      name: 'Time',
      selector: row => row.time,
    },
    {
      name: 'Total Time (min)',
      cell: row => {
        const total = (row.services || []).reduce((sum, s) => {
          const duration = parseInt(s.service_duration || 0, 10);
          return sum + (isNaN(duration) ? 0 : duration);
        }, 0);
        return `${total} min`;
      },
      sortable: true,
    },
    {
      name: 'Status',
      selector: row => row.status,
      cell: row => (
        <span className="badge bg-success white">
          {row.status}
        </span>
      ),
    },
    {
      name: 'Amount ($)',
      selector: row => row.amount,
    },
    {
      name: 'Services',
      cell: row => (
        <ul className="list-unstyled mb-0">
          {row.services.map(service => (
            <li key={service.id}>{service.category}({service.name}) (${service.price})</li>
          ))}
        </ul>
      ),
      grow: 3,
    },
    {
      name: 'Actions',
      cell: row => (
        <button
          className="btn btn-sm btn-outline-primary"
          onClick={() => handleView(row)}
        >
          View
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
    }
  ];

  const handleView = (booking) => {
    navigate('/booking-details', { state: { booking } });
  };

  return (
    <>
      <LoaderOverlay loading={loading} />

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>Confirmed Bookings</h4>
      </div>

      <div className="row mb-3">
        <div className="col-md-6">
          <input
            type="text"
            placeholder="Search"
            className="form-control px-3"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
        <div className="col-md-6">
          <input
            type="date"
            className="form-control px-3"
            value={filterDate}
            onChange={(e) => setFilterDate(e.target.value)}
          />
        </div>
      </div>

      <DataTable
        columns={columns}
        data={filteredData}
        pagination
        highlightOnHover
        striped
        responsive
        noHeader
      />
    </>
  );
};

export default ConfirmedBookings;